import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import useStore from "./useStore";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const {handleSubmit, setErrors, setData, storeFields, reset} = useStore();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`shop-addresses/${id}/edit`).then(res => {
      setData({...res?.data.data, editMode: true});
      reset(res.data.shopAddress);
    });
  }, []);

  const editStore = data => {
    axios.put('shop-addresses/' + id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Store has been updated successfully!', {
            icon: "success",
          });
          navigate("/stores");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit Store">
      <form className="form w-100 row" onSubmit={handleSubmit(editStore)}>
        {storeFields}
        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block"
        />
      </form>
    </Card>
  );
}